<template>
  <v-card flat class="pa-4">
    <v-form ref="priceForm" v-model="valid">
      <div class="text-subtitle-1 font-weight-bold mb-4 primary--text d-flex align-center">
        <v-icon left color="primary">mdi-cash-multiple</v-icon>
        تنظیم قیمت و استپ برای {{ productData?.title }}
      </div>

      <v-row>
        <v-col cols="12" md="6">
          <price-input
            v-model="pricingForm.min_price"
            label="حداقل قیمت مجاز"
            dense
            outlined
            :rules="[(v) => !!v || 'ورود حداقل قیمت الزامی است']"
          />
        </v-col>

        <v-col cols="12" md="6">
          <price-input
            v-model="pricingForm.max_price"
            label="حداکثر قیمت مجاز"
            dense
            outlined
            :rules="[(v) => !!v || 'ورود حداکثر قیمت الزامی است']"
          />
        </v-col>

        <v-col cols="12" md="6">
          <price-input
            v-model.number="pricingForm.price_step"
            label="گام کسر قیمت (تومان)"
            dense
            outlined
            min="2000"
          />
        </v-col>

        <v-col cols="12" md="6" class="d-flex align-center">
          <v-switch
            v-model="pricingForm.is_enabled"
            label="فعال‌سازی الگوریتم هوشمند"
            color="primary"
            hide-details
          />
        </v-col>
      </v-row>

      <div class="d-flex justify-end gap-3 mt-6">
        <v-btn text class="rounded-lg" @click="$emit('close')">انصراف</v-btn>
        <v-btn
          color="primary"
          class="rounded-lg px-6"
          :loading="saving"
          :disabled="!valid"
          @click="savePricing"
        >
          <v-icon left>mdi-check</v-icon>
          ثبت نرخ
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import PriceInput from "../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";

export default {
  name: "QuickPricingModal",
  components: { PriceInput },
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    saving: false,
    pricingForm: {
      min_price: 0,
      max_price: 0,
      price_step: 20000,
      is_enabled: true,
    },
  }),
  methods: {
    async savePricing() {
      this.saving = true;
      try {
        await this.$api.post("/v1/digikala/multi-pricing/store", {
          product_id: this.productData.id,
          ...this.pricingForm,
        });
        this.$toast.success("تنظیمات قیمت با موفقیت ذخیره شد");
        this.$emit("saved");
      } catch (e) {
        this.$toast.error("خطا در ذخیره قیمت‌گذاری");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
